import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'kp-create-team-dialog',
  templateUrl: './create-team-dialog.component.html',
  styleUrls: ['./create-team-dialog.component.scss'],
})
export class CreateTeamDialogComponent {
  teamForm: UntypedFormGroup;
  newTeamSpaceName = '';

  constructor(
    public dialogRef: MatDialogRef<CreateTeamDialogComponent>,
    private fb: UntypedFormBuilder
  ) {
    this.teamForm = this.fb.group({
      newTeamSpaceName: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9 _'-]*$/)]],
    });
  }

  onCreate(): void {
    if (this.teamForm.valid) {
      this.dialogRef.close(this.teamForm.value.newTeamSpaceName);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
